<template>
    <div>
        <!-- <section class="new_pharmacy">
            <div class="description">
                <span> {{$t('investor.LatestNews')}}</span>
                <h3>
                {{ pages[pageNumber].description }}
                </h3>
                <p v-if="pages[pageNumber].list1 !== ''"> {{ pages[pageNumber].list1 }} </p>
                <p v-if="pages[pageNumber].list2 !== ''"> {{ pages[pageNumber].list2 }} </p>
                <p v-if="pages[pageNumber].list3 !== ''"> {{ pages[pageNumber].list3 }} </p>
                <p v-if="pages[pageNumber].list4 !== ''"> {{ pages[pageNumber].list4 }} </p>
                <p v-if="pages[pageNumber].list5 !== ''"> {{ pages[pageNumber].list5 }} </p>
                <p v-if="pages[pageNumber].list6 !== ''"> {{ pages[pageNumber].list6 }} </p>
                <h3>
                {{ pages[pageNumber].descriptionTwo }}
                </h3>
                <a :href="pages[pageNumber].link">
                {{ pages[pageNumber].link }}
                </a>
                <h3>
                {{ pages[pageNumber].descriptionThree }}
                </h3>
                <div class="line"></div>
                <p>
                {{ pages[pageNumber].seconde_description }}
                {{ pages[pageNumber].tag1 }}
                <br>
                {{ pages[pageNumber].tag2 }}
                </p>
                <div class="arrows">
                <div class="arrow" @click="() => changePageNumber('right')">
                    <b-icon icon="chevron-right" font-scale="5" class="icon"></b-icon>
                </div>
                <div class="arrow" @click="() => changePageNumber('left')">
                    <b-icon icon="chevron-left" font-scale="5" class="icon"></b-icon>
                </div>
                </div>
            </div>
            <div class="img_container">
                <img v-if="pages[pageNumber].img" :src="pages[pageNumber].img" alt="newpharmacey" />
                <video controls  v-if="pages[pageNumber].video">
                  <source :src="pages[pageNumber].video" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
            </div>
        </section> -->
        <section class="new_pharmacy">
            <div class="description">
                <span> {{$t('investor.LatestNews')}}</span>
                <div v-html="pages[pageNumber].translation[0].content"></div>
                <div class="arrows">
                <div class="arrow" @click="() => changePageNumber('right')">
                    <b-icon icon="chevron-right" font-scale="5" class="icon"></b-icon>
                </div>
                <div class="arrow" @click="() => changePageNumber('left')">
                    <b-icon icon="chevron-left" font-scale="5" class="icon"></b-icon>
                </div>
                </div>
            </div>
            <div class="img_container">
                <img v-if="pages[pageNumber].image" :src="pages[pageNumber].image" alt="newpharmacey" />
            </div>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'LastNews',
    data(){
        return{
            pageNumber: 0,
            // pages: [
            //     {
            //       description: 'جانب من تكريم الصيادلة المتميزين عن شهر مايو 2024 - المركز الأول- الصيدلي أمير عبد الرحيم محمد العزازي',
            //       img: require("../../../../assets/images/news/amir.jpg"),
            //     },
            //     {
            //       description: 'يسرنا أن نعلن أنه تم بحمد الله افتتاح فرع جديد لصيدلية المجتمع في:  طريق السيل- حي الفيصلية- الطائف.',
            //       link: 'https://maps.app.goo.gl/UDNtcCCnm83pxsDE8',
            //       seconde_description: 'انضموا إلينا في الفرع الجديد واستفيدوا من خدماتنا المتميزة.. ',
            //       descriptionTwo: 'صيدليات_المجتمع .. الريادة_في_خدمة_المجتمع',
            //       img: require("../../../../assets/images/news/faselaTaif.jpg"),
            //     },
            //     {
            //       description: 'يسرنا أن نعلن أنه تم بحمد الله افتتاح فرع جديد لصيدلية المجتمع في:  حي بطحاء قريش- شارع القاضي- مكة المكرمة.',
            //       link: 'https://maps.app.goo.gl/UDNtcCCnm83pxsDE8',
            //       seconde_description: 'انضموا إلينا في الفرع الجديد واستفيدوا من خدماتنا المتميزة..',
            //       descriptionTwo: 'صيدليات_المجتمع .. الريادة_في_خدمة_المجتمع',
            //       img: require("../../../../assets/images/news/grandOpining.jpg"),
            //     },
            //     {
            //       description: 'يسر مجلس إدارة شركة المجتمع الرائدة الطبية دعوة مساهمي الشركة الكرام إلى المشاركة والتصويت في اجتماع الجمعية العامة العادية (الاجتماع الأول) والمقرر انعقاده بمشيئة الله تعالى في تمام الساعة الثامنة مساء يوم الأحد 30 يونيو 2024م الموافق 24-12-1445هـ عن طريق وسائل التقنية الحديثة',
            //       link: 'https://liqaa.com/agm_page/almujtama-egm',
            //       img: require("../../../../assets/images/news/invitations.jpg"),
            //     },
            //     {
            //       description: 'يسرنا أن نعلن أنه تم بحمد الله افتتاح فرع جديد لصيدلية المجتمع في:  حي القيم الأعلى- طريق المطار - الطائف.',
            //       link: 'https://maps.app.goo.gl/mk8h3aeFUJQ11fPH7',
            //       seconde_description: 'انضموا إلينا في الفرع الجديد واستفيدوا من خدماتنا المتميزة.. ✨صيدليات_المجتمع .. ',
            //       video: require("../../../../assets/images/news/newsVideo.mp4"),
            //     },
            //     {
            //       description: 'يسرنا أن نعلن أنه تم -بحمد الله- افتتاح فرع جديد لصيدلية المجتمع في حي الهنداوية- شارع المنصور- أنجم مول - جدة',
            //       img: require("../../../../assets/images/news/mansour.jpg"),
            //     },
            //     {
            //         description: 'يسر صيدليات المجتمع ان تعلن أنه تم - بحمد الله -افتتاح فرع جديد بحي القيم الأعلى - مدينة الطائف (طريق المطار)',
            //         list1:'والفرع يقدم لكم الخدمات الآتية:',
            //         list2:'- مواقف خاصة لعملائنا الكرام.',
            //         list3:'- تلبية جميع احتياجات عملائنا الكرام.',
            //         list4:'- صرف الوصفات الطبية الإلكترونية الصادرة عن طريق نظام وصفتي.',
            //         list5:'- صرف الوصفات الطبية عن طريق التامين الطبي.',
            //         list6:'- خدمة الطب الاتصالي .',
            //         img: require("../../../../assets/images/news/ayamAlAalaa.jpg"),
            //     },
            //     {
            //         description: 'انطلاقاً من مسؤوليتها الوطنية في تدريب وتوظيف الصيادلة من ابناء و بنات وطننا الغالي ، حققت شركة المجتمع الرائدة الطبية بالتعاون مع وزارة الموارد البشرية وصندوق تنمية الموارد البشرية المستهدفات الوطنية بشكل عام و لمهنة (صيدلي) على وجه الخصوص. كما دأبت شركة المجتمع على إيجاد المزيد من فرص العمل المميزة لأبناء الوطن وبناته في مختلف المجالات ورفع نسبة مشاركتهم في هذا القطاع الحيوي الهام.. و في هذا الصدد نتقدم بالشكر إلى العديد من كليات الصيدلة لتنسيقهم المستمر معنا لتدريب طلبة وطالبات كليات الصيدلة بمرحلة الامتياز  وصقل مهاراتهم وتهيئتهم لسوق العمل في مجال تشغيل الصيدلية المجتمعية واعتماده متطلباً وفتح فرص التوظيف و الترقي للادارة والاشراف ،حيث تم و بحمدالله تدريب ما يزيد عن ألف طالب و طالبة على مدار العشر سنوات الماضية . وكان من ثمار هذا التوجه قيام صيدليات المجتمع حالياً بتشغيل عدد من الصيدليات الخارجية بكل من  مستشفى جازان العام ومستشفى صبيا العام ومستشفى الملك عبدالعزيز التخصصي بالطائف ومستشفى جامعة الملك عبدالعزيز بجدة  تدار بصيادلة سعوديون بنسبة ١٠٠%  ولله الحمد. واستمراراً لالتزامنا بالمستهدفات الوطنية لمهنة (صيدلي ) ، نعلن عن فتح التقديم لتوظيف المزيد من  ابنائنا وبناتنا الصيادلة من حملة البكالوريوس.',
            //         seconde_description: 'صيدليات المجتمع.. لمجتمع صحي واع.',
            //         descriptionTwo: 'التقديم عن طريق الدخول الى الموقع الالكتروني:' ,
            //         link: 'https://www.almujtama.com.sa/form',
            //         descriptionThree: 'الهاتف الموحد: 920008144' ,
            //         img: require("../../../../assets/images/news/jobs.jpg"),
            //     },
            //     {
            //     description: 'جانب من تكريم الصيادلة المتميزين عن شهر فبراير 2024 - المركز الخامس- الصيدلي علي محمد علي محمود',
            //     img: require("../../../../assets/images/news/aliMohamedAli.jpg"),
            //     },
            //     {
            //     description: 'يسرنا أن نعلن أنه تم -بحمد الله- افتتاح فرع جديد لصيدلية المجتمع في حي المجد- صبيا- مستشفى صبيا العام- طريق الملك فيصل- جازان',
            //     img: require("../../../../assets/images/news/newFesal.jpg"),
            //     },
            //     {
            //     description: 'يسرنا أن نعلن أنه تم -بحمد الله- افتتاح فرع جديد لصيدلية المجتمع في حي الأندلس- شارع إبراهيم الجفالي - جدة',
            //     img: require("../../../../assets/images/news/newAndalos.jpg"),
            //     },
            //     {
            //     description: 'جانب من تكريم الصيادلة المتميزين عن شهر فبراير 2024 - المركز الرابع- الصيدلي صالح إبراهيم محمد جراد',
            //     img: require("../../../../assets/images/news/salehIbrahem.jpg"),
            //     },
            //     {
            //     description: 'جانب من تكريم الصيادلة المتميزين عن شهر فبراير 2024 - المركز الثالث- الصيدلي محمود مصطفى أحمد محمد',
            //     img: require("../../../../assets/images/news/mostafaAhmedMohamed.jpg"),
            //     },
            //     {
            //     description: 'جانب من تكريم الصيادلة المتميزين عن شهر فبراير 2024 - المركز الثاني- الصيدلي محمد عبد الله حسن مختار',
            //     img: require("../../../../assets/images/news/mohamedAbdallahHassan.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر نوفمبر 2023 - المركز الرابع - الصيدلي هشام سعيد رمضان عبد الجواد',
            //         img: require("../../../../assets/images/news/heshamSaeed.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر نوفمبر 2023 - المركز الخامس - الصيدلي محمد السر عبد الرحمن حمزة',
            //         img: require("../../../../assets/images/news/mohamesElSir.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر ديسمبر 2023 - المركز الأول - الصيدلي كريم نور الدين',
            //         img: require("../../../../assets/images/news/karimNoorElDin.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر ديسمبر 2023 - المركز الثاني - الصيدلي محمد الهجري',
            //         img: require("../../../../assets/images/news/mohamedElHigry.jpg"),
            //     },
            //     {
            //     description: 'جانب من تكريم الصيادلة المتميزين عن شهر ديسمبر 2023 - المركز الثالث - الصيدلي أحمد عطية',
            //     img: require("../../../../assets/images/news/ahmedAtya.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر يناير 2024 - المركز الأول - الصيدلي مصطفى محمود أحمد حسين',
            //         img: require("../../../../assets/images/news/mostafaMahmoudAhmed.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر يناير 2024 - المركز الثاني - الصيدلي محمود أحمد محمود عميرة',
            //         img: require("../../../../assets/images/news/mahmoudAhmedMahmoud.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر يناير 2024 - المركز الثالث - الصيدلي اسلام سعيد أحمد الدناصوري',
            //         img: require("../../../../assets/images/news/eslamSaid.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر يناير 2024 - المركز الرابع - الصيدلي السيد أحمد صالح جمعة',
            //         img: require("../../../../assets/images/news/elSaydAhmed.jpg"),
            //     },
            //     {
            //         description: 'جانب من تكريم الصيادلة المتميزين عن شهر يناير 2024 - المركز الخامس - الصيدلي أحمد محمد أحمد القاضي',
            //         img: require("../../../../assets/images/news/ahmedMohamedAhmed.jpg"),
            //     },
            //     {
            //         description: 'يسرنا أن نعلن أنه تم -بحمد الله- افتتاح فرع جديد لصيدلية المجتمع في حي الزمرد- طريق الملك سعود - جدة',
            //         img: require("../../../../assets/images/news/news7.jpg"),
            //     },
            //     {
            //         description: 'يسرنا أن نعلن أنه تم -بحمد الله- افتتاح فرع جديد لصيدلية المجتمع في حي الزمرد- طريق الملك سعود - جدة',
            //         img: require("../../../../assets/images/news/news7.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.news1'),
            //         img: require("../../../../assets/images/news/news1.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.news2'),
            //         img: require("../../../../assets/images/news/news2.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.news3'),
            //         img: require("../../../../assets/images/news/news3.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.news4'),
            //         img: require("../../../../assets/images/news/news4.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.newBranch'),
            //         tag1: this.$t('slider.newBranchTag1'),
            //         tag2: this.$t('slider.newBranchTag2'),
            //         img: require("../../../../assets/images/newPharmacy.jpg"),
            //         },
            //     {
            //         description:this.$t('slider.TheLeadingCommunityMedical'),
            //         seconde_description: this.$t('slider.TheLeadingCommunityMedicalDescription'),
            //         img: require("../../../../assets/images/newsTrueSign.jpg"),
            //     },
            //     {
            //         description: this.$t('slider.CommunityLeadingMedical'),
            //         seconde_description: this.$t('slider.CommunityLeadingMedicalDescription'),
            //         img: require("../../../../assets/images/new7.jpg"),
            //     },
            //     {
            //         description:this.$t('slider.newOpening'),
            //         seconde_description:this.$t('slider.newOpeningDescription'),
            //         img: require("../../../../assets/images/opening.png"),
            //     },
            //     {
            //         description: this.$t('slider.CollegeOfPharmacy'),
            //         seconde_description:this.$t('slider.Community_Pharmacy'),
            //         img: require("../../../../assets/images/openening2023.png"),
            //     },
            //     {
            //         description:this.$t('slider.TheManagementOfTheLeading'),
            //         descriptionTwo:this.$t('slider.TheManagementOfTheLeadingDescription') ,
            //         img: require("../../../../assets/images/gift.png"),
            //     },
            // ],
            pages: []
        }
    },
    mounted(){
      this.getLastNews();
    },
    methods:{
        getLastNews() {
          axios.get('https://app.almujtama.com.sa/api/listNews',{
            params:{
              'local' : localStorage.getItem('lang')
            }
          })
          .then( response => {
            console.log(response.data.data, 'last news')
            this.pages = response.data.data
          })
        },
        changePageNumber(type) {
            if (type == "left") {
                if (this.pageNumber <= this.pages.length-2 && this.pageNumber > -1) {
                this.pageNumber = this.pageNumber + 1;
                } else {
                this.pageNumber = 0;
                }
            } else if (type == "right") {
                if (this.pageNumber <= this.pages.length && this.pageNumber > 0) {
                this.pageNumber = this.pageNumber - 1;
                } else {
                this.pageNumber = this.pages.length - 1;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.new_pharmacy {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #78a28f;
  padding: 100px 0;
  margin: 100px 0;
  @media (max-width: 991px) {
    flex-direction: column;
    margin: 50px 0;
  }
  .description {
    background-color: #fff;
    padding: 50px;
    width: 750px;
    border-radius: 10px;
    position: relative;
    z-index: 3;
    @media (max-width: 1450px) {
      width: 600px;
    }
    @media (max-width: 1450px) {
      width: 80%;
    }
    @media (max-width: 991px) {
      width: 90%;
      padding: 20px;
      order: 2;
    }
    span {
      font-size: 36px;
      color: #2b5933;
      margin-bottom: 20px;
    }
    h3,
    a {
      font-size: 22px;
      color: #78a28f;
      font-weight: 800;
      margin-bottom: 30px;
      @media (max-width: 1450px) {
        font-size: 30px;
      }
      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
    a:hover{
      color: #d8d253;
    }
    .line {
      height: 3px;
      width: 70px;
      background-color: #d1d13c;
      margin-bottom: 30px;
    }
    p {
      font-size: 16px;
      color: #6f7775;
    }
    .arrows {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      .arrow {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #d8d253;
        cursor: pointer;
        margin-top: 30px;
        .icon {
          font-size: 16px !important;
        }
      }
      .arrow:last-child {
        border: 0;
        margin-right: 10px;
      }
    }
  }
  .img_container {
    margin-right: -50px;
    width: 530px;
    @media (max-width: 1200px) {
      width: 38%;
    }
    @media (max-width: 1450px) {
      margin: 30px 0 0 0;
    }
    @media (max-width: 991px) {
      order: 1;
      width: 90%;
      margin-bottom: 10px;
    }
    img {
      max-width: 100%;
    }
    video{
      width: 100%;
    }
  }
}

.en{
  .arrows{
    .arrow:first-child{
      order: 2;
    }
    .arrow:last-child{
      order: 1;
    }
  }
}
</style>